import { Box, Container } from '@chakra-ui/react';
import { deleteCookie } from 'cookies-next';
import { GetServerSidePropsContext, NextPage } from 'next';
import { useCallback } from 'react';
import { useIntl } from 'react-intl';

import { withCommonServerSideProps } from '@/lib/withCommonServerSideProps';
import useLocalStorage from '@/hooks/useLocalStorage';

import { PageTitle } from '@/components/PageTitle/PageTitle';
import RegisterNoAccount from '@/components/Register/RegisterNoAccount';
import Seo from '@/components/Seo';

import { CookieKeys } from '@/constants/cookie-keys';

const Register: NextPage = () => {
    const intl = useIntl();
    const { removeItem } = useLocalStorage();
    const onRegisterSubmit = useCallback(async () => {
        sessionStorage.removeItem('sponsorNo');
        removeItem('shopping-cart-unlogged', 'local');
    }, [removeItem]);

    return (
        <Container maxW="5xl">
            <Seo templateTitle={intl.formatMessage({ id: 'page.no-account.title' })} />
            <Box py={16}>
                <PageTitle title="page.no-account.title" />
                <RegisterNoAccount onRegisterSubmit={onRegisterSubmit} />
            </Box>
        </Container>
    );
};

export const getServerSideProps = withCommonServerSideProps(
    async (context: GetServerSidePropsContext) => {
        const { req, res } = context;
        deleteCookie(CookieKeys.showLoginDisabledPopup, { req, res });
        return {
            props: {}
        };
    }
);

export default Register;
